function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classnames from 'classnames';
import { SortProductsListingIcon } from 'swag-client-common/components/svg/sort-products-listing.svg';
import { SortHoverProductsListingIcon } from 'swag-client-common/components/svg/sort-hover-products-listing.svg';
import { CustomizableIconButton } from 'swag-client-common/components/ui/customizable-icon-button/customizable-icon-button';
import { getFilter } from 'swag-client-common/utils/tricks';
import { variables } from 'swag-client-common/styles/variables-js';
import { styles } from './popover-settings';
import { ProductsSortingOptions } from './products-sorting-options';
import classes from './products-sorting.scss';
export const ProductsSorting = ({
  sorting,
  isOpen,
  anchorEl,
  openSorting,
  closeSorting,
  sortProducts,
  targetOrigin,
  anchorOrigin,
  secondaryColor,
  primaryColor
}) => {
  _extends(styles.selectedItem, {
    backgroundColor: secondaryColor || variables.colorAlternativePrimary
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container,
    onClick: openSorting
  }, /*#__PURE__*/React.createElement(CustomizableIconButton, {
    dataButton: "Sort by",
    label: "Sort by",
    title: getFilter(sorting, true),
    tooltipDirection: "right",
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    buttonClassName: classes.button,
    tooltipClassName: classes.tooltip,
    iconClassName: classes.icon,
    labelClassName: classes.label,
    titleClassName: classnames(classes.label, classes.sortingName),
    dataTooltip: getFilter(sorting),
    PrimaryIcon: SortProductsListingIcon,
    SecondaryIcon: SortHoverProductsListingIcon
  })), /*#__PURE__*/React.createElement(ProductsSortingOptions, {
    isOpen: isOpen,
    anchorEl: anchorEl,
    anchorOrigin: anchorOrigin,
    targetOrigin: targetOrigin,
    onRequestClose: closeSorting,
    onChange: sortProducts,
    sorting: sorting,
    secondaryColor: secondaryColor
  }));
};